
import { Role } from "../enums/role";
import { MenuItem } from "./menu-item";



export class MeUser {
  agent: null | string = null;
  brand: string = '';
  csiProfile: Role | null = null;
  dealer: string = '';
  dealerGroup: string | null = null;
  dealerName: string = '';
  defaultLocale: string = '';
  distributor: string | null = null;
  elementBrandColor: string = '';
  email: string = '';
  firstBrandColor: string = '';
  market: string = '';
  menu: MenuItem[] = [];
  outlet: string = '';
  pathbrand: string = '';
  profileCodeMenu: string = '';
  region: string = '';
  roles: string[] = [];
  scope: string = '';
  scopeEntities: { network: any; vehicle: any } = { network:'', vehicle: '' };
  secondBrandColor: string = '';
  subRegion: string = '';
  isInternal: string = '';

  constructor(user: {[key: string]:any}) {
    for (let key in user) {
      if (user[key] && typeof user[key] === "string") {
        user[key] = user[key].trim();
      }
    }
    Object.assign(this, user);
    if(user['sub']){
      this.email = user['sub'];
    }

    // if (this.dealerGroup && Array.isArray(this.dealerGroup)) {
    //   this.dealerGroup = this.dealerGroup
    //     .filter((group) => !!group)
    //     .map((group) => group?.trim()) as string[];
    // }
  }

  hasRoles(...roles: string[]): boolean {
    let passedCheck = false;
    for (const role of roles) {
      if (passedCheck) break;
      passedCheck = this.roles.includes(role);
    }
    return passedCheck;
  }

  userHasCsiProfile( ...roles: Role[]): boolean {
    if (this.csiProfile){
      return roles.includes(this.csiProfile)
    }
    else return false;
  }

  userInRegion(...regions: string[]): boolean{
    return regions.includes(this.region)
  }
}
